import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { SvgComponent } from '@shared/components/svg';
import { ResponsiveService } from '@shared/services/responsive';

@Component({
  selector: 'app-star-rating-display',
  standalone: true,
  imports: [SvgComponent],
  templateUrl: './star-rating-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StarRatingDisplayComponent {
  readonly note = input.required<number>();
  readonly size = input<'SMALL' | 'NORMAL'>('NORMAL');
  protected readonly stars = computed<string[]>(() => {
    const full = Math.floor(this.note());
    const half = this.note() % 1 >= 0.5 ? 1 : 0;
    const empty = 5 - full - half;

    return [
      ...Array<string>(full).fill('assets/icons/star-full.svg'),
      ...Array<string>(half).fill('assets/icons/star-half.svg'),
      ...Array<string>(empty).fill('assets/icons/star-empty.svg'),
    ];
  });
  protected readonly breakpoints = inject(ResponsiveService).breakpoints;
}
